import axios from 'axios';
import { useEffect, useState } from 'react'
import { RiArrowDownSLine, RiSortDesc } from "react-icons/ri";
import { toast } from 'react-toastify';
import TableLoader from '../../../../utils/TableLoader';
import PaginationComponent from '../../../../utils/PaginationComponent';
import searchIcon from "../../../../assets/admin/search.svg";
import { sanitizeText } from '../../../../utils/TextUtils';
import { TiTick } from 'react-icons/ti';
import { IoClose } from 'react-icons/io5';
import StockWineListEdit from './StockWineListEdit';
import MasterWineListEdit from './MasterWineListEdit';
import WineListTimeSlotEdit from './WineListTimeSlotEdit';

const WineListEdit = (props) => {
  const {
    totalPages,
    rowsPerPage,
    setRowsPerPage,
    page,
    setPage,
    wineData,
    setWineData,
    wineEditId,
    setWineEditId,
    editWineList,
    setEditWineList,
    wineStockAvailable,
    setWineStockAvailable,
    getWineData,
    getWineListData,
    isLoading,
    setIsLoading,
    searchWine,
    setSearchWine,
    handleSearchChange,
  } = props;

  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");
  // const [restaurentName, setRestaurentName] = useState();
  // const [restaurenDesc, setRestaurentDesc] = useState();

  const [wineFormData, setWineFormData] = useState({
    name: "",
    description: "",
    is_show_filter: 0,
    is_show_sentence: 0
  });

  const [toggleStatus, setToggleStatus] = useState();
  const [statusValue, setStatusValue] = useState("");
  const states = ["Active", "Inactive"];

  const [timeSlots, setTimeSlots] = useState({});
  const [selectedWine, setSelectedWine] = useState([]);
  const [userType, setUserType] = useState('');

  const [priceFilter, setPriceFilter] = useState("asc");
  const [priceType, setPriceType] = useState("bottle_price");

  const [showOption, setShowOption] = useState({
    price: false,
  });

  const toggleDropdown = (key) => {
    setShowOption((prev) => ({
      [key]: !prev[key],
    }));
  };

  useEffect(() => {
    const role = localStorage.getItem("Role");
    setUserType(role)
  }, []);

  const englishToItalian = {
    monday: "Lunedì",
    tuesday: "Martedì",
    wednesday: "Mercoledì",
    thursday: "Giovedì",
    friday: "Venerdì",
    saturday: "Sabato",
    sunday: "Domenica",
  };

  const days = [
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
    "Domenica",
  ];

  // const firstAvailableDay = Object.keys(timeSlots)?.[0] || days?.[0] || "";
  // const [activeDay, setActiveDay] = useState(firstAvailableDay);

  const [activeDay, setActiveDay] = useState(days[0]);

  useEffect(() => {
    if (timeSlots && Object.keys(timeSlots).length > 0) {
      const availableDay = Object.keys(timeSlots).find(day =>
        days.includes(day)
      ) || days[0];
      setActiveDay(availableDay);
    }
  }, [timeSlots]);

  const handleAddTimeSlot = (day) => {
    let isValid = true;
    const currentSlots = timeSlots[day] || [];

    if (currentSlots.some(slot => !slot.start_time || !slot.end_time)) {
      toast.error("Please complete all existing time slots before adding a new one.", { theme: "colored", autoClose: 1000 });
      return;
    }
    for (let i = 0; i < currentSlots.length; i++) {
      const slot = currentSlots[i];
      if (slot.start_time && slot.end_time && slot.start_time >= slot.end_time) {
        toast.error("The end time must be greater than or not equal to the start time.", { theme: "colored", autoClose: 1000 });
        isValid = false;
        break;
      }
    }

    if (isValid) {
      setTimeSlots((prev) => ({
        ...prev,
        [day]: [...(prev[day] || []), { start_time: "00:00", end_time: "23:59" }],
      }));
    }
  };

  const handleTimeSlotChange = (day, index, field, value) => {
    setTimeSlots((prev) => {
      const updatedSlots = [...(prev[day] || [])];
      updatedSlots[index][field] = value;
      return { ...prev, [day]: updatedSlots };
    });
  };

  const validSlot = () => {
    let isValid = true;

    if (statusValue === "Inactive") {
      return true;
    }

    if (Object.keys(timeSlots).length === 0) {
      toast.error("At least one time slot must be added.", { theme: "colored", autoClose: 1000 });
      return false;
    }

    for (let day in timeSlots) {
      const currentSlots = timeSlots[day];

      if (currentSlots.length === 0) {
        toast.error(`At least one time slot is required for ${day}.`, { theme: "colored", autoClose: 1000 });
        isValid = false;
        break;
      }

      for (let i = 0; i < currentSlots.length; i++) {
        const slot = currentSlots[i];

        if (!slot.start_time || !slot.end_time) {
          toast.error(`Both start and end times are required for ${day}.`, { theme: "colored", autoClose: 1000 });
          isValid = false;
          break;
        }

        if (slot.start_time >= slot.end_time) {
          toast.error(`The end time must be greater than or not equal to the start time  ${day}.`, { theme: "colored", autoClose: 1000 });
          isValid = false;
          break;
        }
      }

      if (!isValid) break;
    }

    return isValid;
  };

  const handleRemoveTimeSlot = (key, index) => {
    setTimeSlots((prev) => {
      if (prev && prev[key] && Array.isArray(prev[key])) {
        const updatedTimeSlots = { ...prev };
        updatedTimeSlots[key] = updatedTimeSlots[key].filter((_, i) => i !== index);
        if (updatedTimeSlots[key].length === 0) {
          delete updatedTimeSlots[key];
        }
        return updatedTimeSlots;
      }
      return prev;
    });
  };

  const getSingleWineData = async () => {
    try {
      const res = await axios.get(`${apiUrl}/api/v1/winelists/${wineEditId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // console.log(res?.data?.wine_stock, "get api response ")

      // setRestaurentName(res?.data?.name);
      // setRestaurentDesc(res?.data?.description);
      setStatusValue(res?.data?.status);
      setToggleStatus(false);

      setWineFormData((prev) => ({
        ...prev,
        name: res?.data?.name,
        description: res?.data?.description,
        is_show_filter: res?.data.is_show_filter || 0,
        is_show_sentence: res?.data.is_show_sentence || 0,
      }));
      setPriceType(res?.data?.price_type_filter || "bottle_price");
      setPriceFilter(res?.data?.price_filter || "asc");


      const timeSlotsArray = res?.data?.time_slots || [];
      const transformedTimeSlots = timeSlotsArray.reduce((acc, slot) => {
        const italianDay = englishToItalian[slot.day.toLowerCase()];
        if (!acc[italianDay]) acc[italianDay] = [];
        acc[italianDay].push({
          start_time: slot.start_time.slice(0, 5),
          end_time: slot.end_time.slice(0, 5),
        });
        return acc;
      }, {});
      setTimeSlots(transformedTimeSlots);

      const selectedWineArray = [];

      res?.data?.wine_stock?.forEach((wine) => {
        selectedWineArray.push({
          // wine_stock_id: wineStockAvailable ? wine?.id : wine?.wine_id,
          wine_stock_id: wine?.id,
          // is_wine_from: wine?.pivot?.is_wine_from,
          is_wine_from: "wine-stocks",
          glass_price: wine?.pivot?.glass_price || "0.00",
          bottle_price: wine?.pivot?.bottle_price || "0.00",
          price: wine?.pivot?.price || "0.00",
          quantity: wine?.pivot?.quantity || 1,
          is_show_bottle_price: wine?.pivot?.is_show_bottle_price === 1,
          is_show_glass_price: wine?.pivot?.is_show_glass_price === 1,
        });

      });

      if (wineStockAvailable) {
        setSelectedWine(selectedWineArray);
      } else {
        setSelectedWine(selectedWineArray);
      }

    } catch (err) {
      console.error("Error fetching single wine data:", err);
    }
  };

  const toggleSwitch = (field) => {
    setWineFormData((prev) => ({
      ...prev,
      [field]: prev[field] === 1 ? 0 : 1,
    }));
  };

  const isFormValid = wineFormData.name && selectedWine.length !== 0 && statusValue
  const handleSave = async () => {
    if (statusValue === "Inactive") {
      toast.warn("Inactive status is not allowed. Please select 'Active'.", {
        autoClose: 1000,
        theme: "colored",
      });
      return;
    }

    if (!validSlot()) {
      return;
    }
    setIsLoading({ ...isLoading, main: true });
    const timeSlotsMap = {
      monday: "Lunedì",
      tuesday: "Martedì",
      wednesday: "Mercoledì",
      thursday: "Giovedì",
      friday: "Venerdì",
      saturday: "Sabato",
      sunday: "Domenica",
    };

    const filteredTimeSlots = Object.entries(timeSlotsMap).reduce((acc, [key, value]) => {
      if (Array.isArray(timeSlots?.[value]) && timeSlots[value].length > 0) {
        acc[key] = timeSlots[value];
      }
      return acc;
    }, {});

    // console.log("selectedWine", selectedWine);

    const wineDataObject = {
      name: wineFormData.name,
      description: wineFormData.description,
      status: statusValue,
      wines: selectedWine,
      time_slots: filteredTimeSlots,
      is_show_filter: wineFormData.is_show_filter || 0,
      is_show_sentence: wineFormData.is_show_sentence || 0,
      price_type_filter: priceType || "bottle_price",
      price_filter: priceFilter || "asc",
    };

    try {
      const response = await axios.put(`${apiUrl}/api/v1/winelists/${wineEditId}`,
        wineDataObject, {
        headers: { Authorization: `Bearer ${token}` },
      });

      getWineListData();
      getWineData();
      setEditWineList(false);
      toast.success(response?.data?.message, {
        theme: "colored",
        autoClose: 1000,
      });
    } catch (error) {
      const errors = error?.response?.data?.errors;
      if (errors) {
        for (const key in errors) {
          if (Array.isArray(errors[key])) {
            errors[key].forEach((message) => {
              toast.error(message, {
                theme: "colored",
                autoClose: 3000,
              });
            });
          }
        }
      } else {
        toast.error(error?.response?.data?.message, {
          theme: "colored",
          autoClose: 3000,
        });
      }
    } finally {
      setIsLoading({ ...isLoading, main: false });
      setSelectedWine([]);
      // setRestaurentName("");
      // setRestaurentDesc("");
      setTimeSlots({});
      setWineEditId("");
    }
  };

  const handleCancel = () => {
    setEditWineList(false)
    setSelectedWine([])
    // setRestaurentName()
    // setRestaurentDesc()
    setWineEditId("")
    setSearchWine("")
    setPage(1)
    setWineStockAvailable(true);
  };

  useEffect(() => {
    if (wineEditId) {
      getSingleWineData();
      getWineData();
    }
  }, [wineEditId, editWineList]);

  useEffect(() => {
    if (wineStockAvailable) {
      setSelectedWine((prev) =>
        prev.map((wine) => ({
          ...wine,
        }))
      );
    } else {
      setSelectedWine((prev) =>
        prev.map((wine) => ({
          ...wine,
        }))
      );
    }
  }, [wineStockAvailable]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setToggleStatus(false)
        setShowOption({ price: false });
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <>
      <section>
        <div className="flex md:flex-row flex-col justify-between gap-3">
          <h3 className="text-3xl font-bold mb-2 poppins-medium self-start">Modifica Carta Vini</h3>
          <div className="flex items-center justify-end gap-3 self-start">
           
            <div className="relative group flex justify-end dropdown-container">
              <button
                className="bg-[#f8f1f1] border-[#8B24335C] w-6 inline-flex items-center px-0 py-0 outline-none text-[#DB7685] shadow-sm z-30"
                onClick={() => toggleDropdown("price")}
              >
                <RiSortDesc
                  className={`text-md xl:text-2xl ml-auto transform transition-transform duration-300 ${showOption.price ? "rotate-180" : ""
                    }`}
                />
              </button>
              <div
                className={`${showOption.price
                  ? "opacity-100 z-50"
                  : "opacity-0 overflow-hidden z-20"
                  } bg-[#f8f1f1] h-fit max-h-[320px] min-w-[210px] overflow-hidden absolute top-[35px] pt-[9px] p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out left-0 md:left-auto`}
              >
                <label
                  htmlFor=""
                  className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                >
                  <input
                    type="checkbox"
                    checked={
                      priceFilter === "desc" &&
                      priceType === "bottle_price"
                    }
                    className="outline-none cursor-pointer"
                    onChange={() => {
                      setPriceFilter("desc");
                      setPriceType("bottle_price");
                    }}
                  />
                  <span className="text-[#6B6B6B] text-xs xl:text-sm  rounded-md flex items-center gap-3 poppins-regular text-sm">
                    {/* {t('wineProductPage.bottleHighToLow')} */}
                    Bottiglia: più costosi
                  </span>
                </label>
                <label
                  htmlFor=""
                  className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                >
                  <input
                    type="checkbox"
                    checked={
                      priceFilter === "asc" &&
                      priceType === "bottle_price"
                    }
                    className="outline-none cursor-pointer"
                    onChange={() => {
                      setPriceFilter("asc");
                      setPriceType("bottle_price");
                    }}
                  />
                  <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                    {/* {t('wineProductPage.bottleLowToHigh')} */}
                    Bottiglia: meno costosi
                  </span>
                </label>
                <label
                  htmlFor=""
                  className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                >
                  <input
                    type="checkbox"
                    checked={
                      priceFilter === "desc" &&
                      priceType === "glass_price"
                    }
                    className="outline-none cursor-pointer"
                    onChange={() => {
                      setPriceFilter("desc");
                      setPriceType("glass_price");
                    }}
                  />
                  <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                    {/* {t('wineProductPage.glassHighToLow')} */}
                    Calice: più costosi
                  </span>
                </label>
                <label
                  htmlFor=""
                  className="px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                >
                  <input
                    type="checkbox"
                    checked={
                      priceFilter === "asc" && priceType === "glass_price"
                    }
                    className="outline-none cursor-pointer"
                    onChange={() => {
                      setPriceFilter("asc");
                      setPriceType("glass_price");
                    }}
                  />
                  <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                    {/* {t('wineProductPage.glassLowToHigh')} */}
                    Calice: meno costosi
                  </span>
                </label>
              </div>
            </div>

            <label className="cursor-pointer">
              <input
                type="checkbox"
                checked={wineFormData.is_show_filter === 1}
                onChange={() => toggleSwitch("is_show_filter")}
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                            peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                            after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full 
                            after:transition-all peer-checked:bg-[#8B2433]">
              </div>
            </label>
            <span className="text-sm font-medium poppins-regular text-left">
              {wineFormData.is_show_filter ? "Mostra Filtri" : "Nascondi filtri"}
            </span>
            <label className="cursor-pointer">
              <input
                type="checkbox"
                checked={wineFormData.is_show_sentence === 1}
                onChange={() => toggleSwitch("is_show_sentence")}
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                            peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                            after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full 
                            after:transition-all peer-checked:bg-[#8B2433]">
              </div>
            </label>
            <span className="text-sm font-medium poppins-regular text-left">
              {wineFormData.is_show_sentence ? "Mostra Presentazione" : "Nascondi presentazione"}
            </span>
          </div>
        </div>

        <div className="w-full flex items-center my-5 justify-center flex-wrap">
          <div className="w-full grid md:grid-cols-2 sm:gap-4 gap-1 mb-[18px]">
            <div className="dropdown-main mb-3">
              <div className="relative group w-full bg-[#FFFFFF]">
                <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                  Titolo Carta Vini<span className="text-red-500">*</span>:
                </label>
                <input
                  type="text"
                  placeholder="Titolo della carta dei vini"
                  className="w-full flex justify-between poppins-medium items-center px-4 py-[17px] sm:text-sm text-[13px] text-[#8B8B8B] rounded-[28px] relative z-10 poppins-regular text-xs bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(wineFormData.name || "")}
                  onChange={(e) => setWineFormData({ ...wineFormData, name: e.target.value })}
                />
              </div>
            </div>

            <div className="dropdown-main">
              <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                Stato:
              </label>
              <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                <div className="border border-[#777777] rounded-[28px]">
                  <button
                    className="w-full flex justify-between poppins-medium items-center px-4 py-[17px] sm:text-sm text-[13px] text-[#8B8B8B] rounded-[28px] cursor-pointer relative z-10 poppins-regular text-xs bg-transparent  focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    onClick={() => setToggleStatus(!toggleStatus)}
                  >
                    <span className="mr-2 flex items-center gap-3 poppins-medium">
                      {statusValue === "Active" ? "Attivo" : statusValue === "Inactive" ? "Inattivo" : "Scegli Stato"}
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${toggleStatus ? "rotate-180" : ""
                        }`}
                      size={"24px"}
                      color="#9f414f"
                    />
                  </button>
                  <div
                    className={`${toggleStatus ? "max-h-60 opacity-100 relative" : "max-h-0 opacity-0 overflow-hidden"
                      } bg-[#FFFFFF] rounded-[28px] absolute top-0 p-2 px-4 mt-0 shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out`}
                  >
                    {states
                      .filter((states) => states !== statusValue)
                      .map((states, index, array) => (
                        <label
                          key={states}
                          className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                          onClick={() => { setStatusValue(states); setToggleStatus(false) }}
                        >
                          <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                            {states === "Active" ? "Attivo" : states === "Inactive" ? "Inattivo" : ""}
                          </span>
                        </label>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full grid gap-4">
            <div className="relative group w-full bg-[#FFFFFF]">
              <div className="flex flex-col w-full sm:gap-3 gap-1">
                <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block pb-[12px]">
                  Descrizione:
                </label>
                <textarea
                  rows="4"
                  className="poppins-regular px-4 py-3 text-[16px] text-[#8B8B8B] rounded-[14px] bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(wineFormData.description || "")}
                  onChange={(e) => setWineFormData({ ...wineFormData, description: e.target.value })}
                  placeholder="Descrizione della carta dei vini"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <WineListTimeSlotEdit
            days={days}
            activeDay={activeDay}
            statusValue={statusValue}
            setStatusValue={setStatusValue}
            setActiveDay={setActiveDay}
            timeSlots={timeSlots}
            setTimeSlots={setTimeSlots}
            handleTimeSlotChange={handleTimeSlotChange}
            handleAddTimeSlot={handleAddTimeSlot}
            handleRemoveTimeSlot={handleRemoveTimeSlot}
          />
        </div>
      </section>
      <section>
        {/* toggle wine list */}
        <div className="my-5 dark:border-gray-700">
          <div className="flex items-center justify-between lg:flex-row flex-col gap-3">
            <ul className="flex flex-wrap -mb-px text-sm font-medium text-center self-start" id="default-tab" data-tabs-toggle="#default-tab-content" role="tablist">
              <li className="me-2" role="presentation">
                <button
                  className={`inline-block p-4 ${wineStockAvailable && "border-b-4 border-[#8A2533]"} rounded-t-lg hover:text-gray-600 hover:border-[#8A2533]`} id="profile-tab" data-tabs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false"
                  onClick={() => {
                    setWineStockAvailable(true); setSearchWine(""); setPage(1)
                    // setRowsPerPage(10)
                  }}
                >
                  Scorta di vino
                </button>
              </li>
              {userType === "admin" ? (
                <li className="me-2" role="presentation">
                  <button
                    className={`inline-block p-4 ${!wineStockAvailable && "border-b-4 border-[#8A2533]"} rounded-t-lg hover:text-gray-600 hover:border-[#8A2533]`} id="dashboard-tab" data-tabs-target="#dashboard" type="button" role="tab" aria-controls="dashboard" aria-selected="false"
                    onClick={() => {
                      setWineStockAvailable(false); setSearchWine(""); setPage(1)
                      // setRowsPerPage(10);
                    }}
                  >
                    Lista dei vini
                  </button>
                </li>
              ) : (null)}
            </ul>

            <div className="input-type">
              <div className="relative group xl:w-[400px]">
                <button
                  className="inline-flex h-full justify-between items-center w-full px-6 pl-8 py-2 outline-none text-[#8F8F8F] border border-[#D9D9D9] rounded-full shadow-sm"
                >
                  <input
                    type="text"
                    placeholder="Cerca vino"
                    className="text-[#8F8F8F] outline-none pl-4 poppins-medium relative w-full h-full"
                    value={searchWine || ""}
                    onChange={handleSearchChange}
                  />
                  <img
                    src={searchIcon}
                    className="absolute left-4 top-0 bottom-0 my-auto h-4 w-4"
                    alt="Search"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div id="default-tab-content" className="overflow-auto">
          <div
            className="p-4 xl:w-full sm:w-[1500px] w-full bg-[#F8F8F8] border-[1.5px] border-[#8B24332B] rounded-xl shadow"
            id="dashboard"
            role="tabpanel"
            aria-labelledby="dashboard-tab"
          >
            <table className="w-full text-left wine_table">
              <thead>
                <tr className="border-b border-[#8B2433]">
                  <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]"></th>
                  <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">Immagine</th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Nome</th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Tipologia</th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Nazione</th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Prezzo Pagato (Iva Esclusa)</th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Prezzo Calice (Iva Inclusa)</th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Prezzo Bottiglia (Iva Inclusa)</th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Mostra Prezzi</th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Quantità</th>
                </tr>
              </thead>
              {isLoading?.main ? (
                <TableLoader />
              ) : wineStockAvailable ? (
                <StockWineListEdit
                  wineData={wineData}
                  selectedWine={selectedWine}
                  setSelectedWine={setSelectedWine}
                />
              ) : userType === "admin" ? (
                <MasterWineListEdit
                  wineData={wineData}
                  selectedWine={selectedWine}
                  setSelectedWine={setSelectedWine}
                />
              ) : null}
            </table>
          </div>
          {wineData && wineData?.length > 0 && (
            <PaginationComponent
              page={page}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
            />
          )}
        </div>

        <div className="flex text-sm sm:flex-row flex-col justify-start gap-4 mt-4">
          {isLoading.save ? (
            <button disabled type="button"
              className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
              <svg
                aria-hidden="true"
                className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              Loading...
            </button>
          ) : (
            <button
              // className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
              disabled={!isFormValid || isLoading?.main}
              className={`sm:w-[120px] w-full flex justify-center items-center space-x-2 p-1 px-3  ${isFormValid && !isLoading?.main ? 'bg-[#8A2533] text-white' : 'bg-gray-300 text-gray-600 cursor-not-allowed'
                } border-[1.5px] border-[#d18d97] bg-[#8A2533] rounded-lg transition-colors group w-[120px]`}
              onClick={handleSave}
            >
              <TiTick size={"25px"} color="green" />
              <span className="poppins-regular">Aggiorna</span>
            </button>
          )}
          <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
            onClick={handleCancel}
          >
            <IoClose size={"25px"} color="red" className="group-hover:invert" />
            <span className="poppins-regular">Annulla</span>
          </button>
        </div>

        {/* <div className="flex text-sm justify-start gap-4 mt-4">
          <button
            disabled={!isFormValid || isLoading?.main}
            // className={(!restaurentName || isButtonDisabled) ? "bg-blue-200 px-4 py-2  rounded-xl text-white font-bold" : "bg-blue-400 px-4 py-2  rounded-xl text-white font-bold cursor-pointer"} 
            // className={`sm:w-[120px] w-full flex justify-center items-center space-x-2 p-1 px-3  ${isFormValid && !isLoading?.main ? 'bg-[#8A2533] text-white' : 'bg-gray-300 text-gray-600 cursor-not-allowed'
            //   } border-[1.5px] border-[#d18d97] bg-[#8A2533] rounded-lg transition-colors group w-[120px]`}
            className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
            onClick={() => {
              if (restaurentName) {
                updateWineListData()
                setWineStockAvailable(true);
                setSearchWine("")
              }
            }}>
            <TiTick size={"25px"} color="green" />
            <span className="poppins-regular">Aggiorna</span>
          </button>
          <button className="flex items-center sm:w-[120px] w-full justify-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
            onClick={() => {
              setEditWineList(false)
              setSelectedWine([])
              setRestaurentName()
              setRestaurentDesc()
              setWineEditId("")
              setWineStockAvailable(true);
              setSearchWine("")
              setPage(1)
            }}>
            <IoClose size={"25px"} color="red" className="group-hover:invert" />
            <span className="poppins-regular">Annulla</span>
          </button>
        </div> */}
      </section >
      {/* <div className="flex lg:flex-row flex-col items-center justify-between gap-4 w-full">
        <h3 className="text-3xl font-bold my-2 mt-5 poppins-medium self-start max-w-fit">
          MODIFICA CARTA VINI
        </h3>
        <div className="flex items-center justify-end w-ful lg:self-center self-start gap-4">
          <div className='flex items-center justify-start gap-3 max-w-fit'>
            <label className="cursor-pointer">
              <input
                type="checkbox"
                checked={wineFormData.is_show_filter === 1}
                onChange={() => toggleSwitch("is_show_filter")}
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                          peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                          after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full 
                          after:transition-all peer-checked:bg-[#8B2433]">
              </div>
            </label>
            <span className="text-sm font-medium poppins-regular text-left">
              {wineFormData.is_show_filter ? "mostra filtro" : "Nascondi filtri"}
            </span>

          </div>
          <div className='flex items-center justify-start gap-3 max-w-fit'>
            <label className="cursor-pointer">
              <input
                type="checkbox"
                checked={wineFormData.is_show_sentence === 1}
                onChange={() => toggleSwitch("is_show_sentence")}
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                          peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                          after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full 
                          after:transition-all peer-checked:bg-[#8B2433]">
              </div>
            </label>
            <span className="text-sm font-medium poppins-regular text-left">
              {wineFormData.is_show_sentence ? "mostra la frase" : "Nascondi presentazione"}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-8 flex flex-col gap-2">
        <label className="font-bold">Titolo Carta Vino</label>
        <input
          type="text"
          value={sanitizeText(restaurentName || "")}
          onChange={(e) => {
            setRestaurentName(e.target.value)
          }} className="w-full px-4 py-2 border-2 rounded-xl"
          placeholder="Titolo della carta dei vini" />
      </div>
      <div className="mt-8 flex flex-col gap-2">
        <label className="font-bold">Descrizione Carta Vino</label>
        <textarea
          rows="4"
          className="w-full px-4 py-2 border-2 rounded-xl"
          type="text"
          // name="description"
          value={sanitizeText(restaurenDesc || "")}
          placeholder="Descrizione della carta dei vini"
          onChange={(e) => setRestaurentDesc(e.target.value)}
        />
      </div>

      <div className="mt-5 flex flex-col gap-2">
        <label className="font-bold">Stato</label>
        <div className="relative group w-full dropdown-container">
          <div className="w-full">
            <button
              className={`${toggleStatus ? "border-b-0 rounded-tl-3xl rounded-tr-3xl" : "rounded-full"} border border-[#8B24335C] bg-[#FFFFFF] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
              onClick={() => {
                setToggleStatus(!toggleStatus)
              }}
            >
              <span className="mr-2 flex items-center gap-3 poppins-medium">
                {!statusValue ? "Stato" : statusValue === "Active" ? "Attivo" : "Inattivo"}
              </span>
              <RiArrowDownSLine
                className={`transform transition-transform duration-300 ${toggleStatus ? "rotate-180" : ""
                  }`}
                size={"24px"}
                color="#9f414f"
              />
            </button>
            <div
              className={`${toggleStatus ? "opacity-100 z-40" : "opacity-0 z-0 hidden overflow-hidden"
                } bg-[#FFFFFF] h-fit overflow-hidden absolute top-[28px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
            >
              <label
                htmlFor=""
                className="border-b border-[#8b24331f] px-0 py-2 flex gap-[15px] cursor-pointer"
                onClick={() => {
                  setStatusValue("Active")
                  setToggleStatus(false)
                }}
              >
                Attivo
              </label>
              <label
                htmlFor=""
                className="px-0 py-2 flex gap-[15px] cursor-pointer"
                onClick={() => {
                  setStatusValue("Inactive")
                  setToggleStatus(false)
                }}
              >
                Inattivo
              </label>
            </div>
          </div>
          <EditTimeSlotRestaurant
            days={days}
            activeDay={activeDay}
            statusValue={statusValue}
            setStatusValue={setStatusValue}
            setActiveDay={setActiveDay}
            timeSlots={timeSlots}
            setTimeSlots={setTimeSlots}
            handleTimeSlotChange={handleTimeSlotChange}
            handleAddTimeSlot={handleAddTimeSlot}
            handleRemoveTimeSlot={handleRemoveTimeSlot}
          />
        </div>
      </div> */}
    </>
  )
}

export default WineListEdit;